<template>
  <div class="m-home">
    <!-- ===================== 产品面板 01：电磁流量计（图上文下 + 水波纹） ===================== -->
    <section class="m-panel m-panel--water">
      <div class="m-water" aria-hidden="true">
        <div class="m-water__flow m-water__flow--a"></div>
        <div class="m-water__flow m-water__flow--b"></div>
      </div>
      <div class="m-panel__inner">
        <div class="m-panel__media km-reveal">
          <div class="m-panel__media-glow" aria-hidden="true"></div>
          <img :src="products[0].img" :alt="products[0].name" />
        </div>
        <div class="m-panel__body km-reveal">
          <h2 class="m-h2">{{ products[0].name }}</h2>
          <p class="m-panel__desc">{{ products[0].desc }}</p>
          <a class="km-btn km-btn-primary" href="https://shunmingelectronic.com/meter/">了解更多</a>
        </div>
      </div>
    </section>

    <!-- ===================== 产品面板 02：智控仪表数据云平台（文字上 + 图片下） ===================== -->
    <section class="m-panel m-panel--alt">
      <div class="m-panel__inner">
        <div class="m-panel__body km-reveal">
          <h2 class="m-h2">{{ products[1].name }}</h2>
          <p class="m-panel__desc">{{ products[1].desc }}</p>
          <a class="km-btn km-btn-primary" href="https://shunmingelectronic.com/meter/project#/project">了解更多</a>
        </div>
        <div class="m-panel__media km-reveal">
          <div class="m-panel__media-glow" aria-hidden="true"></div>
          <img :src="products[1].img" :alt="products[1].name" />
        </div>
      </div>
    </section>

    <!-- ===================== 产品面板 03：路灯智能云平台（图上文下） ===================== -->
    <section class="m-panel">
      <div class="m-panel__inner">
        <div class="m-panel__media km-reveal">
          <div class="m-panel__media-glow" aria-hidden="true"></div>
          <img :src="products[2].img" :alt="products[2].name" />
        </div>
        <div class="m-panel__body km-reveal">
          <h2 class="m-h2">{{ products[2].name }}</h2>
          <p class="m-panel__desc">{{ products[2].desc }}</p>
          <a class="km-btn km-btn-primary" @click="handClick('products', { categoryId: products[2].categoryId })">了解更多</a>
        </div>
      </div>
    </section>

    <!-- ===================== 产品面板 04：传统行业物联网改造升级（文字上 + 图片下） ===================== -->
    <section class="m-panel m-panel--alt">
      <div class="m-panel__inner">
        <div class="m-panel__body km-reveal">
          <h2 class="m-h2">{{ products[3].name }}</h2>
          <p class="m-panel__desc">{{ products[3].desc }}</p>
          <a class="km-btn km-btn-primary" @click="handClick('products', { categoryId: products[3].categoryId })">了解更多</a>
        </div>
        <div class="m-panel__media km-reveal">
          <div class="m-panel__media-glow" aria-hidden="true"></div>
          <img :src="products[3].img" :alt="products[3].name" />
        </div>
      </div>
    </section>

    <!-- ===================== 服务能力 ===================== -->
    <section class="km-section m-services">
      <div class="km-container">
        <div class="m-head km-reveal">
          <h2 class="m-h2">我们能为您提供什么</h2>
          <p class="m-lead">从城市照明到工业计量，再到传统行业数字化升级，提供端到端的物联网产品与服务。</p>

          <div class="m-metrics">
            <div class="m-metric">
              <span class="m-metric__num">10<i>+</i></span>
              <span class="m-metric__label">年行业研发经验</span>
            </div>
            <div class="m-metric">
              <span class="m-metric__num">4<i>+</i></span>
              <span class="m-metric__label">核心解决方案</span>
            </div>
            <div class="m-metric">
              <span class="m-metric__num">4G</span>
              <span class="m-metric__label">无缝数据传输</span>
            </div>
            <div class="m-metric">
              <span class="m-metric__num">24/7</span>
              <span class="m-metric__label">实时监控管理</span>
            </div>
          </div>
        </div>

        <div class="m-stack">
          <article v-for="(item, i) in services" :key="i" class="km-card m-card km-reveal">
            <div class="m-card__icon"><img :src="item.icon" :alt="item.title" /></div>
            <h3 class="m-h3">{{ item.title }}</h3>
            <p class="m-card__desc">{{ item.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- ===================== CTA ===================== -->
    <section class="km-section m-cta-wrap">
      <div class="km-container">
        <div class="m-cta km-reveal">
          <div class="m-cta__glow"></div>
          <span class="km-eyebrow">开始合作</span>
          <h2 class="m-h2">准备好开启智能化升级了吗？</h2>
          <p class="m-cta__lead">告诉我们您的目标与挑战，我们将为您提供清晰的下一步方案。</p>
          <a class="km-btn km-btn-primary" @click="handClick('contact')">立即联系</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { jumpPage } from '@/utils/public';
import { getProductInfo } from '../../utils/auth';
export default {
  name: 'HomeView',
  data() {
    return {
      services: [
        { icon: require('../../assets/ludeng.png'), title: '智慧照明管理', desc: '针对城市照明路灯及园林景观灯，提供故障实时报警、远程集中控制、单灯节能管理，并支持能源消耗统计，助力智慧城市高效节能管理与运营优化。' },
        { icon: require('../../assets/meter.png'), title: '高精度计量模块', desc: '提供具备超高计量精度和出色线性度表现的计量模块，确保在各种复杂工况下仍可提供稳定、可靠的计量结果，满足工业级别要求。' },
        { icon: require('../../assets/yunpingtai.png'), title: '物联网整体方案', desc: '凭借十余年物联网整体解决方案的研发经验，推动各行业数字化转型与智能化升级，帮助传统行业提升效率和竞争力。' }
      ],
      products: [
        { name: '电磁流量计转换器', categoryId: 4, img: 'https://qiniu.shunmingelectronic.com/guanwang/product/%E5%B0%8F%E8%93%9D%E6%AD%A3%EF%BC%88%E5%8E%8B%E7%BC%A9%EF%BC%89.png', desc: '高精度电磁流量计转换器，稳定可靠，适用于多种复杂工况下的流量测量与监控。' },
        { name: '智控仪表数据云平台', categoryId: 2, img: 'https://qiniu.shunmingelectronic.com/guanwang/product/denglulong.png', desc: '集中管理仪表数据，实时监控与可视化分析，让数据驱动决策更高效。' },
        { name: '路灯智能云平台', categoryId: 1, img: 'https://qiniu.shunmingelectronic.com/guanwang/product/lighttoumingbeijing.png', desc: '面向城市照明的智能云平台，远程控制、节能管理与故障报警一体化。' },
        { name: '传统行业物联网改造升级', categoryId: 3, img: 'https://qiniu.shunmingelectronic.com/guanwang/product/nongyegaizao.png', desc: '将数字化与信息化理念融入传统行业，实现优势互补与效率跃升。' }
      ],
      categoryList: []
    }
  },
  methods: {
    handClick(val, query) {
      jumpPage(val, query);
    },
    setupReveal() {
      const els = this.$el.querySelectorAll('.km-reveal');
      if (!('IntersectionObserver' in window)) {
        els.forEach(el => el.classList.add('is-visible'));
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(el => io.observe(el));
      this._io = io;
    }
  },
  mounted() {
    this.categoryList = getProductInfo();
    // 首次进入有进场页，等其消失后再触发首屏动画；后续导航则立即触发
    if (document.querySelector('.intro-screen')) {
      this._revealTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.setupReveal();
        });
      }, 3300);
    } else {
      this.$nextTick(() => {
        this.setupReveal();
      });
    }
  },
  beforeUnmount() {
    if (this._io) this._io.disconnect();
    if (this._revealTimer) clearTimeout(this._revealTimer);
  }
}
</script>

<style scoped>
.m-home {
  background: var(--bg);
  overflow: hidden;
}

/* ===================== 产品面板 ===================== */
.m-panel {
  position: relative;
  display: flex;
  align-items: center;
  padding: 64px 0;
  overflow: hidden;
  background: var(--bg);
}

/* 仅电磁流量计占满整屏，其余产品按内容合理分配高度 */
.m-panel--water {
  min-height: 100vh;
  padding: 96px 0 64px;
}

.m-panel--alt {
  background: #f5f7fb;
}

.m-panel__inner {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 0 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

/* 图片 */
.m-panel__media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.m-panel__media-glow {
  position: absolute;
  inset: 6% 8%;
  background: radial-gradient(circle at 50% 50%, rgba(93, 174, 255, 0.22), transparent 68%);
  filter: blur(22px);
  z-index: 0;
}

.m-panel__media img {
  position: relative;
  z-index: 1;
  max-width: 90%;
  max-height: 42vh;
  object-fit: contain;
  filter: drop-shadow(0 22px 44px rgba(15, 18, 24, 0.16));
}

/* 文字 */
.m-panel__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
}

.m-panel__desc {
  color: var(--text-soft);
  font-size: 15px;
  line-height: 1.7;
  margin: 0;
  max-width: 460px;
}

/* 水波纹背景（电磁流量计，轻量 CSS，移动端流畅） */
.m-water {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
  -webkit-mask-image: radial-gradient(130% 90% at 40% 40%, #000 40%, transparent 82%);
  mask-image: radial-gradient(130% 90% at 40% 40%, #000 40%, transparent 82%);
}

.m-water__flow {
  position: absolute;
  top: -10%;
  left: 0;
  width: 200%;
  height: 130%;
  background-repeat: repeat;
  background-size: 50% 100%;
  will-change: transform;
}

.m-water__flow--a {
  background-image: repeating-linear-gradient(78deg,
      rgba(22, 131, 224, 0) 0px,
      rgba(22, 131, 224, 0.10) 46px,
      rgba(93, 174, 255, 0.20) 84px,
      rgba(22, 131, 224, 0.10) 122px,
      rgba(22, 131, 224, 0) 168px);
  filter: blur(7px);
  animation: m-flow 6s linear infinite;
}

.m-water__flow--b {
  background-image: repeating-linear-gradient(96deg,
      rgba(93, 174, 255, 0) 0px,
      rgba(93, 174, 255, 0.10) 70px,
      rgba(124, 104, 238, 0.14) 120px,
      rgba(93, 174, 255, 0) 196px);
  filter: blur(9px);
  opacity: 0.85;
  animation: m-flow 9s linear infinite;
}

@keyframes m-flow {
  from {
    transform: translateX(-50%);
  }

  to {
    transform: translateX(0);
  }
}

@media (prefers-reduced-motion: reduce) {

  .m-water__flow--a,
  .m-water__flow--b {
    animation: none !important;
  }
}

/* ===================== 标题 & 区块 ===================== */
.m-section {
  padding: 64px 0;
}

.m-h2 {
  font-family: var(--font-display);
  font-size: 28px;
  line-height: 1.15;
  letter-spacing: -0.02em;
  font-weight: 700;
  margin: 0;
}

.m-h3 {
  font-family: var(--font-display);
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

/* ===================== 服务能力 ===================== */
.m-services {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(50% 22% at 8% 3%, rgba(93, 174, 255, 0.16), transparent 62%),
    radial-gradient(48% 20% at 94% 16%, rgba(22, 131, 224, 0.12), transparent 62%),
    radial-gradient(50% 20% at 4% 62%, rgba(22, 131, 224, 0.10), transparent 62%),
    radial-gradient(52% 22% at 96% 88%, rgba(93, 174, 255, 0.13), transparent 62%);
}

.m-services::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(15, 18, 24, 0.08) 1px, transparent 1px);
  background-size: 20px 20px;
  -webkit-mask-image: linear-gradient(180deg, transparent 0%, #000 10%, #000 90%, transparent 100%);
  mask-image: linear-gradient(180deg, transparent 0%, #000 10%, #000 90%, transparent 100%);
  pointer-events: none;
  z-index: 0;
}

.m-services>.km-container {
  position: relative;
  z-index: 1;
}

.m-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
  margin-bottom: 36px;
}

.m-lead {
  color: var(--text-soft);
  font-size: 15px;
  line-height: 1.7;
  margin: 0;
  max-width: 460px;
}

/* 指标数据 */
.m-metrics {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px 16px;
  width: 100%;
  margin-top: 16px;
  padding-top: 28px;
  border-top: 1px solid var(--border);
}

.m-metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.m-metric__num {
  font-family: var(--font-display);
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--text);
}

.m-metric__num i {
  color: var(--accent);
  font-style: normal;
}

.m-metric__label {
  font-size: 13px;
  color: var(--text-soft);
}

.m-stack {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* 服务卡片 */
.m-card {
  padding: 28px 24px;
  text-align: left;
}

.m-card__icon {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  background: var(--accent-soft);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.m-card__icon img {
  width: 46px;
  height: 46px;
  object-fit: contain;
}

.m-card__desc {
  color: var(--text-soft);
  font-size: 14px;
  line-height: 1.7;
  margin: 12px 0 0;
}

/* ===================== CTA ===================== */
.m-cta-wrap {
  padding-top: 0;
  padding-bottom: 72px;
}

.m-cta {
  position: relative;
  overflow: hidden;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  background: linear-gradient(180deg, #f7f8fa, #eef1f6);
  padding: 48px 26px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.m-cta__glow {
  position: absolute;
  bottom: -160px;
  left: 50%;
  transform: translateX(-50%);
  width: 400px;
  height: 320px;
  background: radial-gradient(circle at 50% 50%, rgba(93, 174, 255, 0.25), rgba(93, 174, 255, 0) 65%);
  pointer-events: none;
}

.m-cta> :not(.m-cta__glow) {
  position: relative;
  z-index: 1;
}

.m-cta .km-eyebrow {
  font-size: 14px;
  padding: 9px 20px;
}

.m-cta__lead {
  color: var(--text-soft);
  font-size: 15px;
  line-height: 1.7;
  margin: 0;
}

/* ===================== 动态加载 ===================== */
.km-reveal {
  opacity: 0;
  transform: translateY(26px);
  transition: opacity 0.7s ease, transform 0.7s ease;
}

.km-reveal.is-visible {
  opacity: 1;
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  .km-reveal {
    opacity: 1 !important;
    transform: none !important;
  }
}
</style>
